<template>
  <ul class="vuejs-countdown">
    <span class="countdown-lead-text">Expiring:</span>
    <li v-if="days > 0">
      <p>{{ days | twoDigits }} {{ days > 1 ? 'days' : 'day' }}</p>
    </li>
    <li>
      <p>{{ hours | twoDigits }} {{ hours > 1 ? 'hours' : 'hour' }}</p>
    </li>
    <li>
      <p>{{ minutes | twoDigits }} min</p>
    </li>
    <li>
      <p>{{ seconds | twoDigits }}Sec</p>
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'

let interval = null
export default {
  name: 'CountdownAdmin',
  props: {
    deadline: {
      type: String
    },
    talent: {
      type: Object
    }
  },
  data () {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0
    }
  },
  created () {
    if (!this.deadline) {
      throw new Error("Missing prop 'deadline'")
    }
    let endTime = this.deadline
    this.date = Math.trunc(Date.parse(endTime.replace(/-/g, '/')) / 1000)
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline'")
    }
    interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)
  },
  computed: {
    seconds () {
      return Math.trunc(this.diff) % 60
    },
    minutes () {
      return Math.trunc(this.diff / 60) % 60
    },
    hours () {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days () {
      return Math.trunc(this.diff / 60 / 60 / 24)
    },
    stateTalentResponseExpired: {
      get () {
        return this.talent.response.expired
      },

      set () {
        this.setRequestTalentProperty({ id: this.talent.id, property: 'response.expired', value: true })
      }
    }
  },
  watch: {
    now (value) {
      this.diff = this.date - this.now
      if (this.diff <= 0) {
        this.diff = 0
        // Remove interval
        clearInterval(interval)
        if (!this.stateTalentResponseExpired) {
          this.setTalentExpiredTrue()
        }
      }
    }
  },
  methods: {
    ...mapActions('booking/request', ['setRequestTalentProperty']),

    setTalentExpiredTrue () {
      this.stateTalentResponseExpired = true
    }
  },
  filters: {
    twoDigits (value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  },
  destroyed () {
    clearInterval(interval)
  }
}
</script>
<style>
.vuejs-countdown {
  padding-left: 0px !important;
}
.vuejs-countdown li {
  display: inline-block;
  padding-left: 0px !important;
}
.vuejs-countdown li p {
  margin: 0;
  overflow: unset;
}
.countdown-lead-text {
  color: red;
  overflow: unset;
}
</style>
